import{_ as a}from"./_assocIndexOf.js";var r=a;var _=function(a){var _=this.__data__,o=r(_,a);return o<0?void 0:_[o][1]};export{_};
